import * as React from 'react'
import * as firebase from 'firebase'

const Login = () => {
  let emailField: HTMLInputElement | null
  let passwordField: HTMLInputElement | null

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (emailField && passwordField && firebase.auth) {
      firebase.auth().signInWithEmailAndPassword(emailField.value, passwordField.value)
        .then(console.log)
        .catch(console.error)
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <label>
        Email: <input type="email" ref={el => emailField = el} />
      </label>

      <label>
        Password: <input type="password" ref={el => passwordField = el} />
      </label>

      <input type="submit" value="Log in" />
    </form>
  )
}

export default Login



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Login.tsx